import { axiosClient, axiosSSOConfigPrivate } from '../../api';
import { API_USERS_DELETE_REQUEST, API_USERS_DELETE_CONFIRM } from '../urls';

export const requestUserDelete = async () =>
  axiosClient.get(API_USERS_DELETE_REQUEST, axiosSSOConfigPrivate());

export const confirmUserDelete = async (code = '') =>
  axiosClient.get(`${API_USERS_DELETE_CONFIRM}?code=${code}`, axiosSSOConfigPrivate());
